<template>
  <div>
    <!-- <a-input-search
      style="margin-bottom: 8px"
      :placeholder="searchTit"
      class="tree-search"
      @change="onChange"
    /> -->
    <div class="tree-list">
      <a-tree
        draggable
        :default-expanded-keys="[datas.options[0].key]"
        :expanded-keys="expandedKeys"
        :tree-data="datas.options"
        :auto-expand-parent="autoExpandParent"
        @expand="onExpand"
        @drop="onDrop"
      >
        <template
          slot="key"
          slot-scope="{title}"
        >
          <OperaTreeNode
            :item-data="title"
            :datas="datas"
            :serword="searchValue"
            @addName="addName"
            @editForm="editForm"
            @addForm="addForm"
          />
        </template>
      </a-tree>
    </div>
  </div>
</template>

<script>
import OperaTreeNode from './OperaTreeNode'
import { mapState, mapMutations } from 'vuex'
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: { title: data[i].title.title } })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}
const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}
export default {
  components: {
    OperaTreeNode
  },
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    this.loop(this.datas.options, null)
    generateList(this.datas.options)
    return {
      expandedKeys: [],
      searchValue: '',
      defaultExpandParent: [],
      autoExpandParent: false
    }
  },
  computed: {
    ...mapState('config/collect', ['treeDatas']),
    searchTit () {
      return this.$t('message["1156"]')
    }
  },
  watch: {
    treeDatas: {
      handler (val) {
        this.loop(val, null)
        generateList(val)
      },
      immediate: true
    }
  },

  methods: {
    ...mapMutations('config/collect', ['setTreeData']),

    onDrop (info) {
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.datas.options]

      // Find dragObject
      let dropObj
      loop(data, dropKey, (item, index, arr) => {
        dropObj = item
      })
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        dragObj = item
      })
      if (dragObj.pid === dropObj.pid) {
        if (!info.dropToGap) {

        } else if (
          (info.node.children || []).length > 0 && info.node.expanded && dropPosition === 1 // On the bottom gap
        ) {

        } else {
          loop(data, dragKey, (item, index, arr) => {
            if (item.pid === dropObj.pid) {
              arr.splice(index, 1)
            }
          })
          let ar
          let i
          loop(data, dropKey, (item, index, arr) => {
            ar = arr
            i = index
          })
          if (dropPosition === -1) {
            ar.splice(i, 0, dragObj)
          } else {
            ar.splice(i + 1, 0, dragObj)
          }
        }
      }

      this.datas.options = data
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange (e) {
      const value = e.target.value
      const expandedKeys = dataList.map((item) => {
        if (item.title.title.indexOf(value) > -1) {
          return getParentKey(item.key, this.datas.options)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      })
    },
    loop (arr, pid) {
      arr.forEach((item, index) => {
        item['scopedSlots'] = { title: 'key' }
        item['key'] = item.id || item._id
        item['pid'] = pid
        item.title = {
          title: item.name,
          index: index,
          key: item.id ? item.id : item._id,
          addShow: item.addShow || false,
          name: item.name,
          level: item.level,
          pid: pid
        }
        if (item.children && item.children.length > 0) {
          this.loop(item.children, item.id)
        }
      })
    },
    addName (itemData, datas) {
      this.loop(datas, null)
      this.expandedKeys.push(itemData.key)
    },
    editForm (datas) {
    },
    addForm (datas) {
      this.loop(datas, null)
    }
  }
}
</script>
<style lang="scss" scoped>
  .tree-search {
    width: 320px;
  }
  .tree-list::v-deep {
    .ant-tree li .ant-tree-node-content-wrapper {
      height: 36px;
      line-height: 36px;
      padding: 0 16px 0 32px;
    }
    .ant-tree li span[draggable], .ant-tree li span[draggable='true'] {
      height: 36px;
      line-height: 36px;
    }
    .ant-tree li span.ant-tree-switcher,
    .ant-tree li span.ant-tree-iconEle {
      height: 36px;
      line-height: 36px;
    }
    .ant-tree li span.ant-tree-switcher {
      left: 32px;
    }
    .ant-tree li .ant-tree-node-content-wrapper:hover,
    .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
      height: 36px;
      line-height: 36px;
      background: #f4f7f9;
    }
  }
</style>
